import { render, staticRenderFns } from "./Warranties.vue?vue&type=template&id=4f49573e&"
import script from "./Warranties.vue?vue&type=script&lang=js&"
export * from "./Warranties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports